import { render } from "./EventsCard.vue?vue&type=template&id=1bde4ba6&scoped=true"
import script from "./EventsCard.vue?vue&type=script&lang=js"
export * from "./EventsCard.vue?vue&type=script&lang=js"

import "./EventsCard.vue?vue&type=style&index=0&id=1bde4ba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bde4ba6"]])

export default __exports__